import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { CountryDto } from '@/models/CountryDto';
import { SelectOption } from '@/models/SelectOption';

export class CountryService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/countries');
  }

  async getAll(): Promise<string[]> {
    return await this.client.get('');
  }

  async getAllDto(): Promise<CountryDto[]> {
    return await this.client.get('');
  }

  async getAllSelectOptions(includeAll: boolean = false): Promise<SelectOption[]> {
    let countries = await this.getAllDto();
    let result = countries.map<SelectOption>(c => {
      return { text: c.CountryCode, value: c.CountryId };
    });

    if (includeAll) {
      result.unshift({ text: 'ALL', value: '' });
    }

    return result;
  }
}
